import { render, staticRenderFns } from "./SliderSetting.vue?vue&type=template&id=634fa5d4&"
import script from "./SliderSetting.vue?vue&type=script&lang=js&"
export * from "./SliderSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634fa5d4')) {
      api.createRecord('634fa5d4', component.options)
    } else {
      api.reload('634fa5d4', component.options)
    }
    module.hot.accept("./SliderSetting.vue?vue&type=template&id=634fa5d4&", function () {
      api.rerender('634fa5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/SliderSetting.vue"
export default component.exports